/**
 * 核心服务页面翻译 - 中文
 * Core Service page translations - Chinese
 */

export default {
  hero: {
    title: '核心服务',
    subtitle: '围绕企业数字化转型全生命周期，提供从战略规划、基础设施建设到日常运营的端到端服务组合',
    imageAlt: '核心服务背景图'
  },

  nav: {
    title: '服务分类'
  },

  portfolio: {
    eyebrow: 'Service Portfolio',
    introTitle: '端到端服务组合',
    introDescription:
      '我们的服务组合围绕企业数字化转型的全生命周期构建，从战略规划、实施部署到持续运营，帮助客户在不同区域获得一致、稳定且可复制的 IT 服务能力。',
    serviceContentTitle: '服务内容',
    coreValueTitle: '核心价值',
    sections: [
      {
        id: 'digital-workplace',
        icon: 'fas fa-laptop',
        image: '/images/coreService/it-base.jpg',
        title: '数字化工作场所',
        subtitle: '打造高效、稳定、统一的数字化办公体验',
        description:
          '面向企业员工的日常办公与协作场景，提供终端、账号、协作工具、远程办公与资产生命周期管理，提升员工生产力和服务体验。',
        serviceItems: [
          { icon: 'fas fa-desktop', text: '终端设备与办公环境支持（笔记本、桌面设备、移动设备）' },
          { icon: 'fas fa-user-cog', text: '员工入离职 IT 支持（账号、设备、权限）' },
          { icon: 'fas fa-comments', text: '办公软件与协作工具支持' },
          { icon: 'fas fa-mobile-alt', text: '远程办公与移动办公支持' },
          { icon: 'fas fa-boxes', text: 'IT 资产与设备生命周期管理' },
          { icon: 'fas fa-chart-line', text: '数字化工作体验优化' }
        ],
        valueItems: [
          {
            icon: 'fas fa-globe-asia',
            title: '区域统一管理',
            points: ['统一 SLA 标准', '集中服务管理', '跨区域协调']
          },
          {
            icon: 'fas fa-building',
            title: '本地交付能力',
            points: ['各国本地工程师网络', '快速响应机制', '现场与远程协同']
          },
          {
            icon: 'fas fa-language',
            title: '多语言支持',
            points: ['中文 / 英文 / 日文 / 韩文', '跨文化沟通', '多区域服务体验一致']
          }
        ]
      },
      {
        id: 'data-center-network',
        icon: 'fas fa-network-wired',
        image: '/images/coreService/base-operatoin.jpg',
        title: '数据中心与网络基础设施服务',
        subtitle: '保障核心业务系统持续稳定运行',
        description:
          '覆盖企业网络、办公网络、门店网络、数据中心网络、服务器与存储设备的建设和运维，帮助客户提升核心系统稳定性和业务连续性。',
        serviceItems: [
          { icon: 'fas fa-network-wired', text: '企业网络部署与维护（LAN / WAN / WiFi）' },
          { icon: 'fas fa-building', text: '门店网络与办公网络支持' },
          { icon: 'fas fa-tools', text: '网络设备安装与配置（交换机、防火墙等）' },
          { icon: 'fas fa-search', text: '网络故障排查与性能优化' },
          { icon: 'fas fa-server', text: '数据中心网络与机房网络管理' },
          { icon: 'fas fa-database', text: '服务器与存储设备支持' },
          { icon: 'fas fa-clipboard-check', text: '数据中心运维与巡检' }
        ],
        valueItems: [
          {
            icon: 'fas fa-shield-alt',
            title: '提升稳定性',
            points: ['提升系统稳定性与可用性', '降低核心系统故障概率', '形成可持续运维机制']
          },
          {
            icon: 'fas fa-exclamation-triangle',
            title: '降低中断风险',
            points: ['快速定位网络与设备故障', '减少业务中断时间', '支持紧急现场响应']
          },
          {
            icon: 'fas fa-business-time',
            title: '保障连续性',
            points: ['支撑关键业务连续运行', '覆盖总部、门店与数据中心', '适配多区域运营管理']
          }
        ]
      },
      {
        id: 'retail-store-ops',
        icon: 'fas fa-store',
        image: '/images/industrySolution/industry-ticketAI.jpg',
        title: '门店 IT 运维解决方案',
        subtitle: '面向多国家、多门店的标准化运维支持',
        description:
          '面向零售、连锁门店与跨区域业务，提供规模化、标准化的门店 IT 运维服务，确保每一家门店稳定营业并获得一致的支持体验。',
        serviceItems: [
          { icon: 'fas fa-headset', text: '门店日常 IT 运维与故障响应' },
          { icon: 'fas fa-desktop', text: '门店设备管理（POS、终端设备等）' },
          { icon: 'fas fa-network-wired', text: '门店网络与系统支持' },
          { icon: 'fas fa-plus-circle', text: '新店开业 IT 部署与上线' },
          { icon: 'fas fa-sync-alt', text: '门店搬迁、升级与关闭支持' }
        ],
        valueItems: [
          {
            icon: 'fas fa-check-circle',
            title: '稳定营业',
            points: ['确保每一家门店稳定运行', '降低设备与网络故障影响', '覆盖日常运营关键场景']
          },
          {
            icon: 'fas fa-bolt',
            title: '快速响应',
            points: ['快速响应问题', '减少营业影响', '远程诊断与现场处理结合']
          },
          {
            icon: 'fas fa-sitemap',
            title: '统一管理',
            points: ['跨区域门店统一管理', '标准化交付流程', '集中追踪服务质量']
          }
        ]
      },
      {
        id: 'cloud-operations',
        icon: 'fas fa-cloud',
        image: '/images/coreService/cloud-it.jpg',
        title: '云计算与云运维服务',
        subtitle: '构建灵活、高效、可持续优化的云架构',
        description:
          '帮助企业规划、部署、迁移和持续运营云环境，覆盖公有云、混合云、云资源管理、监控安全与成本优化，支撑业务快速变化。',
        serviceItems: [
          { icon: 'fas fa-project-diagram', text: '云环境部署与架构设计（公有云 / 混合云）' },
          { icon: 'fas fa-cloud-upload-alt', text: '云迁移与系统上云' },
          { icon: 'fas fa-cogs', text: '云资源管理与运维' },
          { icon: 'fas fa-shield-alt', text: '云监控与安全管理' },
          { icon: 'fas fa-chart-pie', text: '云成本优化' }
        ],
        valueItems: [
          {
            icon: 'fas fa-expand-arrows-alt',
            title: '灵活扩展',
            points: ['提升 IT 灵活性与扩展能力', '支持业务峰值与快速部署', '适配多云与混合云场景']
          },
          {
            icon: 'fas fa-coins',
            title: '成本优化',
            points: ['优化资源使用', '控制云成本结构', '持续追踪资源效率']
          },
          {
            icon: 'fas fa-rocket',
            title: '快速响应变化',
            points: ['支持业务快速变化', '缩短应用上线周期', '提升云上运营透明度']
          }
        ]
      },
      {
        id: 'digital-transformation',
        icon: 'fas fa-rocket',
        image: '/images/home/home-ai-empowerment.jpg',
        title: '数字化转型支持',
        subtitle: '从传统 IT 运维升级为数据驱动管理模式',
        description:
          '围绕会员运营、营销自动化、轻量服务入口、知识沉淀与办公自动化，帮助企业将 IT 能力沉淀为可复制、可规模化的数字化运营体系。',
        serviceItems: [
          {
            icon: 'fas fa-users',
            text: 'CRM 软件开发：围绕会员、标签、积分权益、互动触达与复购运营，构建 C 端会员 CRM 平台。'
          },
          {
            icon: 'fas fa-bullhorn',
            text: 'MA 营销自动化：连接官网、CRM、邮件与消息渠道，形成线索培育与营销旅程闭环。'
          },
          {
            icon: 'fas fa-mobile-alt',
            text: '小程序：面向预约、报修、查询、会员服务等场景，提供定制开发。'
          },
          {
            icon: 'fas fa-brain',
            text: 'AI 知识库：统一 FAQ、SOP、工单经验与产品资料，支持语义检索与权限管理。'
          },
          {
            icon: 'fas fa-robot',
            text: '办公智能体：打通邮件、审批、会议纪要、任务流转与知识问答，提升内部协同效率。'
          }
        ],
        valueItems: [
          {
            icon: 'fas fa-database',
            title: '数据驱动',
            points: ['从“人驱动”转向“数据驱动”', '沉淀运营数据资产', '提升管理决策质量']
          },
          {
            icon: 'fas fa-tachometer-alt',
            title: '效率透明',
            points: ['提升运营效率与透明度', '减少重复人工操作', '统一流程和服务入口']
          },
          {
            icon: 'fas fa-layer-group',
            title: '规模复制',
            points: ['构建可复制的 IT 管理体系', '支持多区域推广', '形成持续优化机制']
          }
        ]
      }
    ]
  }
}
